import React from 'react';
import { useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import * as types from '../../types';
import styles from './ReferralBanner.module.scss';
import { ReactComponent as ReferralIcon } from '../../assets/images/icons/icon_gift_box.svg';
import useIsReferralCheckoutV2 from '../../hooks/useIsReferralCheckoutV2';

export default function ReferralBanner() {
  const { t } = useTranslation();
  const cart = useSelector((state: types.AppState) => state.storeShop.cart);
  const referrerName = cart.referrerName;
  const referrerAvatarUrl = cart.referrerAvatarUrl;
  const referrerPetAvatarUrl = cart.referrerPetAvatarUrl;
  const hasAvatars = !!referrerAvatarUrl || !!referrerPetAvatarUrl;
  const isV2 = useIsReferralCheckoutV2();

  // Referrer name may not exist if referral code was applied before referrer name was fetched which can
  // occur for older sessions that were created before we started fetching referrer name on referral code apply.
  const referralMessage = isV2
    ? referrerName
      ? t('referral_v2_banner_title', { referrerName })
      : t('referral_v2_banner_title_generic')
    : referrerName
      ? t('referrer_name_invited_you_to_fi', { referrerName })
      : t('you_were_invited_to_fi');

  const subtitle = isV2 ? t('referral_v2_banner_subtitle') : t('special_offer_was_applied_to_your_cart');

  return (
    <div className={styles.container}>
      {isV2 ? (
        <div className={styles.v2Content}>
          {hasAvatars ? (
            <div className={styles.avatarContainer}>
              {referrerPetAvatarUrl && <img src={referrerPetAvatarUrl} alt="" className={styles.avatar} />}
              {referrerAvatarUrl && (
                <img src={referrerAvatarUrl} alt="" className={`${styles.avatar} ${styles.avatarOverlap}`} />
              )}
            </div>
          ) : (
            <div className={styles.iconContainer}>
              <ReferralIcon width={23} height={20} />
            </div>
          )}
          <div className={styles.textContainer}>
            <div className={styles.top}>{referralMessage}</div>
            <div className={styles.bottom}>{subtitle}</div>
          </div>
        </div>
      ) : (
        <div className={styles.content}>
          <div className={styles.top}>
            <ReferralIcon width={23} height={20} className={styles.icon} />
            {referralMessage}
          </div>
          <div className={styles.bottom}>{subtitle}</div>
        </div>
      )}
    </div>
  );
}
